import { isClient } from '@vueuse/core'

export * from './functions'
export * from './strings'

export const defaultWindow = /* #__PURE__ */ isClient ? window : undefined
export const isClientSide = !import.meta.env.SSR
